import { Pressable, View } from 'react-native';

import { Body } from './Body';
import { Eyebrow } from './Eyebrow';

export function FooterColumn({
  title,
  links,
}: {
  title: string;
  links: { label: string; onPress?: () => void }[];
}) {
  return (
    <View className="gap-3">
      <Eyebrow className="mb-0.5 text-[10.5px] tracking-[0.14em] text-faint">
        {title}
      </Eyebrow>
      {links.map((link) => (
        <Pressable key={link.label} onPress={link.onPress} disabled={!link.onPress}>
          <Body className="text-sm text-foreground-secondary">{link.label}</Body>
        </Pressable>
      ))}
    </View>
  );
}
